import Vue from 'vue';
import Vuex from 'vuex';
import GlobalModule from './modules/global';
import LoginModule from './modules/login';
import ContactModule from './modules/contacts';
import SurveyModule from './modules/surveys';
import QuestionModule from './modules/questions';
import RoundModule from './modules/rounds';
import ClientModule from './modules/client';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global: GlobalModule,
    login: LoginModule,
    contact: ContactModule,
    survey: SurveyModule,
    question: QuestionModule,
    round: RoundModule,
    client: ClientModule
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js